import actionTypes from './actionTypes'

// 更新面包屑
export const updateBread = preState => ({
  type: actionTypes.UPDATEBREAD,
  payload: {...preState}
})
